"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tags_1 = require("./Tags");
exports.default = Tags_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Tags/index.js
// module id = 669
// module chunks = 8